import { useState } from "react";
import styled, { keyframes } from "styled-components";
import { t } from "@lingui/core/macro";
import { resetPwdApiCall } from "./Api.js";
import toast, { Toaster } from "react-hot-toast";
import Navbar from "./Navbar.js";

const jump = keyframes`
  from{
    transform: translateY(0)
  }
  to{
    transform: translateY(-3px)
  }
`;

const Form = styled.form`
  margin: 0 auto;
  width: 90%;
  max-width: 414px;
  padding: 1.3rem;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const Input = styled.input`
  max-width: 100%;
  padding: 11px 13px;
  background: #f9f9fa;
  color: #f03d4e;
  margin-bottom: 0.9rem;
  border-radius: 4px;
  outline: 0;
  border: 1px solid rgba(245, 245, 245, 0.7);
  font-size: 14px;
  transition: all 0.3s ease-out;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.1), 0 1px 1px rgba(0, 0, 0, 0.1);
  :focus,
  :hover {
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.15), 0 1px 5px rgba(0, 0, 0, 0.1);
  }
`;

const Button = styled.button`
  max-width: 100%;
  padding: 11px 13px;
  color: rgb(253, 249, 243);
  font-weight: 600;
  text-transform: uppercase;
  background: #f03d4e;
  border: none;
  border-radius: 3px;
  outline: 0;
  cursor: pointer;
  margin-top: 0.6rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-out;
  &:hover {
    background: rgb(200, 50, 70);
    animation: ${jump} 0.2s ease-out forwards;
  }
`;

const Span = styled.span`
  text-align: left;
`;
const Link = styled.a`
  display: inline;
  align-items: center;
  color: #bf4f74;
  cursor: pointer;
`;

/**
 * A component that displays a reset password form
 *
 * @param {object} props
 * @returns {JSX.Element}
 */
const ResetPwd = (options) => {
  const [login, setLogin] = useState({
    password: "",
  });
  // Initialize a boolean state
  const [passwordShown, setPasswordShown] = useState(false);
  const [resetted, setResetted] = useState(false);

  /**
   * A function that manages a reset submit request calling a reset pwd api
   * @param {object} e - An event object
   * @returns {void} Return a feedback message ad set a variable of state
   */
  const handleSubmitReset = (e) => {
    e.preventDefault();
    resetPwdApiCall(login, options.id, options.token)
      .then((data) => {
        if (data.success) {
          toast(t`Password changed successfully`, {
            icon: "👋",
          });
          setResetted(true);
        } else {
          toast(data.error.message || t`Generic reset error`, {
            icon: "🥵",
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  /**
   * A function that manages a pwd value change
   * @param {object} e - An event object
   * @returns {void} Set a variable of state
   */
  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setLogin({ ...login, [name]: value });
  };

  /**
   * A function that manages password shown toggling
   * @returns {void} Call a filtering search map function
   */
  const togglePassword = () => {
    // When the handler is invoked inverse the boolean state of passwordShown
    setPasswordShown(!passwordShown);
  };

  return (
    <div className="App">
      <header className="App-header">
        <p>SA GUIDA – Lawrence2025</p>
        <Navbar />
      </header>
      {resetted ? (
        <Link href="/">{t`Show Go to login`} </Link>
      ) : (
        <Form onSubmit={handleSubmitReset}>
          <Input
            type={passwordShown ? "text" : "password"}
            name="password"
            placeholder="Password"
            value={login.password}
            onChange={handleChange}
          />
          <Span>
            <input type="checkbox" onClick={togglePassword} />
            {t`Show password`}
          </Span>

          <Button>{t`Reset`}</Button>
        </Form>
      )}
      <Toaster position="bottom-center" />
    </div>
  );
};

export default ResetPwd;
